<template>
    <section class="timetable">
        <ul class="timetable__list-institutes institutes container">
            <li class="institutes__item item row">
                <div class="institute_calendar">
                    <div id="mouths" class="mouth-grid" v-html="renderWeek[0]"></div>
                    <div id="days" class="days-grid" v-html="renderWeek[1]"></div>
                </div>
            </li>
        </ul>
    </section>
</template>
<script>
import {mapGetters} from "vuex";

export default{
    data:()=>({
        paginationNext: 8,
        currentYear: new Date().getFullYear()
    }),
    computed: {
        ...mapGetters(['getCalendar','getCurrentDay']),

        renderWeek(){
            let mouthsContainer = '';
            let daysContainer = '';
            if(this.getCalendar[0].weeks?.length > 0 && this.getCalendar[0].months?.length > 0) {
                if(mouthsContainer.length === 0){
                    mouthsContainer += `<div class="firstDiv"> </div>`;
                }
                if(daysContainer.length === 0){
                    daysContainer += `<div class="leftPanel">Пн</div>`;
                    daysContainer += `<div class="leftPanel">Вт</div>`;
                    daysContainer += `<div class="leftPanel">Ср</div>`;
                    daysContainer += `<div class="leftPanel">Чт</div>`;
                    daysContainer += `<div class="leftPanel">Пт</div>`;
                    daysContainer += `<div class="leftPanel">Сб</div>`;
                    daysContainer += `<div class="leftPanel">Вс</div>`;
                    daysContainer += `<div class="leftPanel">№</div>`;
                    daysContainer += `<div class="leftPanel">Ч/З</div>`;
                }
                const countWeeks = this.getCalendar[0].weeks?.length;
                let countWeek = 1;
                if(countWeeks > 0){
                    let countMonth = 0;
                    let lastDay = 0;
                    let weekInMonth = 0;
                    for(let week = 0; week < countWeeks; week++){
                        if(this.getCalendar[0].weeks[week].length > 0){
                            let isToday = false;
                            let isTodayWeek = false;
                            for(let day = 0; day < this.getCalendar[0].weeks[week].length;day++){
                                const currentDay = new Date(this.getCalendar[0].weeks[week][day]).getDate();
                                const currentMonth = new Date(this.getCalendar[0].weeks[week][day]).getMonth();
                                const currentYear = new Date(this.getCalendar[0].weeks[week][day]).getFullYear();
                                isToday = currentDay === new Date().getDate() && currentMonth === new Date().getMonth() && currentYear === new Date().getFullYear();
                                if(isToday) {
                                    isTodayWeek = true;
                                }
                                if(week > 3){
                                    if(lastDay > currentDay){
                                        for(let empty = 1; empty < 10; empty++){daysContainer += `<div class="emptyWeek">.</div>`;}
                                        let currentMonth = this.getCalendar[0].months[countMonth];
                                        mouthsContainer += `<div style="width:${35*(week - weekInMonth + 1)+1.7}px">${currentMonth}</div>`;
                                        weekInMonth = week
                                        countMonth++;
                                    }
                                }
                                if(countMonth < 11) daysContainer += `<div class="${isToday ? 'today' : ''}">${currentDay}</div>`;
                                lastDay = currentDay;
                            }
                            if(week == 1){
                                const firstDaySeptember = new Date(new Date(this.getCalendar[0].weeks[2][0]).getFullYear(), 8, 1).getTime();
                                const saturday = new Date(this.getCalendar[0].weeks[week-1][5]).getTime();
                                const sunday = new Date(this.getCalendar[0].weeks[week-1][6]).getTime();
                                if((saturday == firstDaySeptember) || (sunday == firstDaySeptember)){
                                    countWeek--;
                                }
                            }
                            if(countMonth < 11) daysContainer += `<div class="countWeek ${isTodayWeek ? 'today' : ''}">${countWeek}</div>`;
                            if(countMonth < 11) daysContainer += `<div class="weekCount ${isTodayWeek ? 'today' : ''}">${(countWeek%2===0)?" Зн":" Чс"}</div>`;
                            isTodayWeek = false;
                            countWeek++;
                        }
                    }
                }
            }
            return [mouthsContainer, daysContainer]
        }
    },
    watch: {
        
    }
}
</script>
<style>
  .institute_calendar {
    overflow-x: auto;
  }
  .mouth-grid {
    display: grid;
    grid-template-columns: repeat(50, 1fr);
    grid-auto-flow: column;
  }
  .mouth-grid div { font-weight: bold;width: 27px; height: 32px; padding: 3px; text-align: center; border: 1px solid #eee; border-bottom: 2px solid black; font-family: serif; font-size: 16px;color: black;}
  .mouth-grid .firstDiv {border: none;width: 35px;}
  .days-grid {
    width: 2050px;
    column-count: auto;
    column-width: 34.8px;
    column-gap: 0;
    height:330px;
  }
  .days-grid div { width:35px;height: 35px;padding: 3px; text-align: center; border: 1px solid #eee; font-family: serif;font-size: 16px; color: black;}
  .days-grid .leftPanel {font-weight: bold; border-right: 2px solid black;width:35px;}
  .days-grid .countWeek {font-weight: bold; border-top: 2px solid black;}
  .days-grid .weekCount {font-weight: bold;}
  .days-grid .emptyWeek {border: none;color:white;}
  .days-grid .today { background: #ffcc00; font-weight: bold; }
</style>